import angular from "angular";

angular
    .module('app')
    .component('groupImportStudentsRegisterNew', {
        template: require('./group-import-students-register-new.html'),
        controller: ['$http', 'RequestsQueue', 'Notifier', controller],
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        }
    });

function controller ($http, RequestsQueue, Notifier) {
    let $ctrl = this;

    $ctrl.setPassword = null;
    $ctrl.password = null;
    $ctrl.registered = 0;

    $ctrl.$onInit = function () {
        $ctrl.users = $ctrl.resolve.users;
        $ctrl.registerQueue = $ctrl.resolve.registerQueue;
    };


    $ctrl.registerNewUsers = function () {
        let params;




        $ctrl.close({
            $value: $ctrl.users
        });
    };


    $ctrl.dismissModal = function () {
        if (confirm('Вы действительно хотите закрыть окно?')) {
            $ctrl.close();
        } else {
            $ctrl.dismiss();
        }
    };
}
